import React from 'react';
import TruLogo from '../layout/TruLogo';
const SignInHeader = () => /*#__PURE__*/React.createElement("h3", {
  style: {
    overflow: 'auto'
  }
}, /*#__PURE__*/React.createElement("div", {
  width: "100%",
  height: "100%"
}, /*#__PURE__*/React.createElement("div", {
  style: {
    float: 'left'
  }
}, /*#__PURE__*/React.createElement("a", {
  href: "/"
}, /*#__PURE__*/React.createElement(TruLogo, {
  width: "80px"
}))), /*#__PURE__*/React.createElement("div", {
  style: {
    float: 'right',
    padding: '5px'
  }
}, "Sign In")));
export default SignInHeader;